/* eslint-disable react/no-unescaped-entities */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-console */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import {
  Typography, Grid, Card, Divider,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import groupServices from '../../../redux/services/groupServices';
import companyServices from '../../../redux/services/companyServices';

const moment = require('moment');

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '100%',
    minHeight: '250px',
  },
  semesterDataContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  examDataContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  semesterTitle: {
    fontSize: '25px',
  },
  semesterSubTitle: {
    fontSize: '15px',
  },
  cardHeader: {
    backgroundColor: '#1bb1e4',
    color: '#FFF',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cardBody: {
    width: '90%',
    height: '100%',
    margin: 'auto',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  cardBodyWeb: {
    height: '80%',
  },
  center: {
    textAlign: 'center',
    margin: 'auto',
    width: '100%',
    height: '100%',
  },
  midContainer: {
    height: 'min-content',
  },
  title: {
    padding: '1em',
    textAlign: 'left',
    maxHeight: 50,
    fontWeight: 'bold',
  },
  boldTitle: {
    paddingRight: '1em',
    maxHeight: 50,
    fontWeight: 'bold',
  },
  actionArea: {
    width: '100%',
    height: '100%',
  },
  subTitle: {
    paddingBottom: '0.5em',
  },
}));

const FormatDate = (date, format) => {
  const formatedDate = date ? moment(date).format(format) : '';
  return formatedDate;
};

const getGap = (date1, date2, additionalTime) => {
  const dateDiff = new Date(date2) - new Date(date1);
  const diffMins = Math.round(dateDiff / 60 / 1000); // minutes
  let hoursDiff = Math.round((diffMins - (diffMins % 60)) / 60);
  const daysDiff = hoursDiff / 24;
  hoursDiff %= 24;
  return `${daysDiff >= 1 ? `${Math.round(daysDiff)} day${daysDiff > 1 ? 's' : ''} ` : ''}
  ${hoursDiff >= 1 ? `${hoursDiff}h` : ''}${diffMins % 60 < 10 && diffMins % 60 > 0 ? '0' : ''}
  ${diffMins % 60 > 0 ? `${diffMins % 60}min` : ''}
  ${additionalTime && additionalTime > 0 ? ` + ${additionalTime}min extra time` : ''}`;
};

const ExamsDates = ({ company, userData }) => {
  const classes = useStyles();
  const [semesterData, setSemesterData] = useState(null);
  const [examData, setExamData] = useState([]);
  const { innerWidth: width } = window;
  const isSmallScreen = width < 450;

  useEffect(() => {
    groupServices.getGroupsDataByCompagny(company._id)
      .then((res) => {
        const tmp = [];
        if (res.data) {
          for (const _group in res.data) {
            const group = res.data[_group];
            // eslint-disable-next-line max-len
            if (group.elearning && group.elearning.elearningOptions && group.level === 1 && userData.semester === group.semester) {
              group.elearning.elearningOptions.forEach((option) => {
                tmp.push({ ...option, semester: group.semester });
              });
            }
          }
        }
        tmp.sort((a, b) => (a.beginData > b.beginData ? 1 : -1));
        setExamData(tmp.splice(0, 3));
      });
  }, []);

  useEffect(() => {
    companyServices.getCompanyDataById(company._id)
      .then((res) => {
        if (res.semesters && res.semesters.length > 0) {
          res.semesters.forEach((semester) => {
            if (semester.semester === userData.semester) {
              setSemesterData(semester);
            }
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, [company]);

  return (
    <Card container className={classes.root}>
      <Card
        className={classes.actionArea}
      >
        <Grid container direction="row" className={classes.center}>
          <Grid item md={12} className={classes.cardHeader}>
            <Typography
              variant="body1"
              className={classes.title}
            >
              WELCOME TO MEDICAL WORLD
            </Typography>
          </Grid>
          <Grid container direction="row" className={[classes.cardBody, !isSmallScreen ? classes.cardBodyWeb : null]}>
            <div className={classes.semesterDataContainer}>
              {
                semesterData !== null
                  ? (
                    <>
                      <Typography className={classes.semesterTitle}>
                        {`Semester ${semesterData.semester},`}
                      </Typography>
                      <Typography className={classes.semesterSubTitle}>
                        {`from ${FormatDate(semesterData.beginDate, 'DD MMMM YYYY')} to ${FormatDate(semesterData.endDate, 'DD MMMM YYYY')}`}
                      </Typography>
                    </>
                  )
                  : (
                    <Typography />
                  )
              }
            </div>
            {
              semesterData !== null && examData.length > 0
                ? <Divider style={{ margin: '15px' }} />
                : null
            }
            { examData.length > 0
              ? (
                <div className={classes.examDataContainer}>
                  <Typography className={classes.semesterTitle}>
                    Dates d'examens prévus :
                  </Typography>
                  {
                  (examData.map((exam) => (
                    <Typography className={classes.semesterSubTitle}>
                      {`${FormatDate(exam.examBegin, 'DD/MM/YYYY')} at ${FormatDate(exam.examBegin, 'hh:mm')} for ${getGap(exam.examBegin, exam.examEnd, userData.additionalTime)}`}
                    </Typography>
                  )))
                }
                </div>
              )
              : null}
          </Grid>
        </Grid>
      </Card>
    </Card>
  );
};

ExamsDates.propTypes = {
  company: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired,
};

function mapState(state) {
  const { userData } = state.user;
  const { company } = userData;
  return { company, userData };
}
export default connect(mapState, null)(ExamsDates);
